import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IEquipmentEvent } from './last-equipment-events.model';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, TableComponent } from '@ui-lib/components';
import { RouterLink } from '@angular/router';
import { getLastEquipmentEventsTableColumnsConfig } from './last-equipment-events.constants';
import { AsyncPipe, DatePipe } from '@angular/common';
import { EquipmentEventLocalizationService } from '../../../../shared/services/equipment-event-localization.service';
import { LastEquipmentEventsService } from './last-equipment-events.service';
import { LoadingState } from '../../../../shared/types/loading.type';
import {
  getEquipmentEventDescription,
  getEquipmentEventSeverityClass,
} from '../../../../shared/helpers/equipment-event-description.helpers';

@Component({
  selector: 'mon-last-equipment-events',
  imports: [TranslateModule, ButtonComponent, RouterLink, TableComponent, DatePipe, AsyncPipe],
  templateUrl: './last-equipment-events.component.html',
  styleUrl: './last-equipment-events.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LastEquipmentEventsService],
})
export class LastEquipmentEventsComponent {
  protected readonly lastEquipmentEventsService = inject(LastEquipmentEventsService);
  protected readonly eventLocalization = inject(EquipmentEventLocalizationService);

  protected readonly LoadingState = LoadingState;

  protected readonly columns = getLastEquipmentEventsTableColumnsConfig();

  protected readonly asEquipmentEvent = (item: unknown): IEquipmentEvent => item as IEquipmentEvent;
  protected readonly getSeverityClass = getEquipmentEventSeverityClass;

  protected getEventDescription(event: IEquipmentEvent | undefined): string {
    return getEquipmentEventDescription(this.eventLocalization, event);
  }
}
